import React, { useState, useEffect, useRef } from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import './style.css';
import { isInViewport, SERVER_URL } from '../../utils';

const  Categories = (props) => {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const navRef = useRef(null);
  console.log("Categories-ProductType", props.productType);
  console.log('SELECTED CATEGORY', selected);

  //Sample address: http://localhost:3000/?id=55&name=test
  const queryParams = new URLSearchParams(window.location.search);
  let anyrace_brand = 0;
  if (queryParams.get('anyrace_brand')){
    anyrace_brand = queryParams.get('anyrace_brand');
  }
  
  useEffect(() => {
      fetch(`${SERVER_URL}/wp-json/anyrace_product_list/categories/${props.productType}`)
        .then((res) => res.json())
        .then((o) => {
          const categoriesList = Object.keys(o).map((key) => ({
            slug: o[key].slug,
            name: o[key].name,
            image: o[key].image
          }));
          console.log("categories", categoriesList);
          setCategories(
            categoriesList
          );
          if (categoriesList.length > 0) {
            console.log("SLUG", categoriesList[0].slug)
            props.selectedCallback(categoriesList[anyrace_brand].slug);
            setSelected(categoriesList[anyrace_brand].slug);
          } else {
            props.selectedCallback(null);
            setSelected(null);
          }
          
        });
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      setTimeout(() => {
        const offsetWidth = navRef.current.scrollWidth - navRef.current.offsetWidth;
        if (navRef.current.scrollLeft === offsetWidth) {
          navRef.current.scrollLeft = 0;
          console.log(navRef.current.scrollLeft, offsetWidth);
          console.log("Condition First", offsetWidth);
          setShowRightArrow(true);
          //setShowLeftArrow(false);
        } else if(navRef.current.scrollLeft <= 20)  {
          navRef.current.scrollLeft = 0;
          setShowRightArrow(true);
          //setShowLeftArrow(true);
          console.log("Condition second", offsetWidth); 
        }

        if (navRef.current.scrollWidth === navRef.current.offsetWidth) {
          setShowRightArrow(false);
          console.log("Condition third", offsetWidth);
        }
        console.log("Condition ALL", navRef.current.scrollLeft, navRef.current.scrollWidth, navRef.current.offsetWidth);
      }, 500);
    }

    
  }, [categories]);
  
  const catergoryClicked = (entry) => {
    props.selectedCallback(entry.slug);
    setSelected(entry.slug);
  };

  

    return (
      (categories.length > 0) && (<>
        <div className="categories">
          <div className="left-arrow">
            {
              showLeftArrow && (
                <a className="arrow-button" onClick={() => {
                  navRef.current.scrollLeft -= navRef.current.offsetWidth;
                }}>
                  <ArrowBackIosIcon htmlColor="#666" fontSize="small" />
                </a>
              )
            }
          </div>
          

          <div className="category" ref={navRef} onScroll={(e) => {
            
            const { clientWidth, scrollWidth, scrollLeft } = e.target;
            if (scrollLeft + clientWidth === scrollWidth) {
              setShowRightArrow(false);
              setShowLeftArrow(true);
            } else {
              setShowRightArrow(true);
            }

            if (scrollLeft <= 20) {
              setShowLeftArrow(false)
            } else {
              setShowLeftArrow(true)
            }

            console.log("Condition SCROLL", scrollLeft, (scrollLeft + clientWidth), scrollWidth);

          }}>

            
            {categories.map((entry, index) => (
              <div className={`${selected === entry.slug ? "active-yellow-border" : ''} logo`} key={index} onClick={()=> catergoryClicked(entry)}>
                <img alt={entry.name} src={entry.image} />
                {/* <p>{entry.name}</p> */}
              </div>
            ))}

          </div>
          <div className="right-arrow">
            {
              showRightArrow && (<a className="arrow-button" onClick={() => {
                navRef.current.scrollLeft += navRef.current.offsetWidth;
            }}>
                <ArrowForwardIosIcon htmlColor="#666" fontSize="small" />
                
              </a>)
            }
            </div>

        </div>
      </>)
    );
}

export default Categories;
